import { getSport } from "./library";
import If from "../If/component";
import IconState from "./IconState";
export default function SportsGrid(props) {
    const {
        sports,
        getPreference,
        title,
        showIcons = false,
        onChange,
        classes = [],
    } = props;
    return (
        <>
            <div className="legend">
                <p className="legendTitle">{title}</p>
                <If value={showIcons}>
                    <ul className="legendIcons">
                        <li>
                            <span className="selectSport">
                                <IconState value={false} aria-hidden="true" />
                            </span>
                            <span className="legendText">Unselected</span>
                        </li>

                        <li>
                            <IconState value={true} aria-hidden="true" />
                            <span className="legendText">Selected</span>
                        </li>
                    </ul>
                </If>
            </div>
            <ul className={`sportsList ${classes}`}>
                {sports.map((sportId) => {
                    const sport = getSport(sportId);
                    let checked = getPreference(sportId);
                    return (
                        <li key={sportId}>
                            <label className="sportsName">
                                <input
                                    type="checkbox"
                                    name={sport.name}
                                    checked={checked}
                                    onChange={() => onChange(sportId, !checked)}
                                />
                                {sport.name}
                                <span className="selectSport">
                                    <IconState value={checked} />
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </>
    );
}
